module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"add_dev":"Add Devices","sel_dev":"Select Devices"},"fr":{"add_dev":"Ajouter des appareils","sel_dev":"Choisir un appareil"},"sw":{"add_dev":"Ongeza Vifaa","sel_dev":"Ongeza Vifaa"}}')
  delete Component.options._Ctor
}
